import React, { useContext } from 'react'
import { useMutation } from '@apollo/client'
import MixpanelTracker from '../../../utils/MixpanelTracker'
import { Rating } from 'semantic-ui-react'
import { UPDATE_JOB_MUTATION } from '../../../graphql/job'
import DataContext from '../../../contexts/DataContext'

const Past = ({ project, job }) => {
  const { advisor } = useContext(DataContext)
  const [updateRating] = useMutation(UPDATE_JOB_MUTATION)

  const submitExperience = (e, { rating }) => {
    updateRating({
      variables: {
        userId: advisor.id,
        projectId: project.id,
        job: {
          ratingByExpert: rating,
        },
      },

      update: () => {
        MixpanelTracker.trackRateProject(project, rating)
      },
    })
  }
  return (
    <>
      {['Completed', 'Paid'].includes(job.overall_status) && (
        <span
          style={{
            color: '#000',
            fontWeight: 'bold',
            paddingTop: '5px',
          }}
        >
          Rating:{' '}
          <Rating
            icon="star"
            defaultRating={job.ratingByExpert || 0}
            maxRating={5}
            onRate={submitExperience}
          />
        </span>
      )}
    </>
  )
}

export default Past
